// import React, { useEffect, useState } from "react";
// import Swal from "sweetalert2";
// import { HiOutlineChevronLeft } from "react-icons/hi";
// import { HiChevronRight } from "react-icons/hi2";
// import { FaTicketAlt, FaPaperclip, FaCheckCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL;
// const profileImage = `${process.env.REACT_APP_Image_URL}/support_tickets/`;

// function AllCreatedTicketSupport() {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [errors, setErrors] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [TicketSupportLists, setTicketSupportLists] = useState([]);
//   const navigate = useNavigate();

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchCreatedTicketSupport = async (page = 1) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Authentication token not found.");

//       const response = await fetch(
//         `${API_URL}/created-ticket-support-lists?page=${page}&limit=10`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 401) throw new Error("Unauthorized.");
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to fetch tickets.");
//       }

//       const data = await response.json();
//       setTicketSupportLists(data.data || []);
//       setTotalPages(data.data.totalPages || 1);
//       setCurrentPage(page);
//     } catch (err) {
//       console.error(err);
//       setError(err.message);
//       setTicketSupportLists([]);
//       Swal.fire("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCreatedTicketSupport();
//   }, []);

//   const handlePageChange = (pageNumber) => {
//     if (!totalPages || pageNumber < 1 || pageNumber > totalPages) return;
//     setCurrentPage(pageNumber);
//     fetchCreatedTicketSupport(pageNumber);
//   };

//   const handleStatusChange = (id, value) => {
//     setTicketSupportLists((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, status: value } : item))
//     );
//   };

//   const handleResolutionChange = (id, value) => {
//     setTicketSupportLists((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, resolution: value } : item
//       )
//     );
//   };

//   const updateTicketRequest = async (item) => {
//     try {
//       const token = getAuthToken();
//       if (!item.resolution || item.resolution.trim() === "") {
//         setErrors((prev) => ({
//           ...prev,
//           [item.id]: "Resolution / Remark is required",
//         }));
//         return;
//       }
//       setErrors((prev) => ({ ...prev, [item.id]: "" }));

//       const payload = {
//         ticket_no: item.ticket_no,
//         status: item.status,
//         resolution: item.resolution,
//         resolved_by: "Admin",
//         assigned_to: "Admin",
//         resolved_at: new Date()
//           .toISOString()
//           .slice(0, 19)
//           .replace("T", " "),
//       };

//       const response = await fetch(`${API_URL}/update-ticket-status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (response.ok && result.success === "1") {
//         Swal.fire("Success", result.message, "success");
//         fetchCreatedTicketSupport(currentPage);
//       } else {
//         Swal.fire("Error", result.message || "Update failed", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", err.message, "error");
//     }
//   };

//   // 🎨 Badge Colors
//   const getPriorityStyle = (priority) => {
//     switch (priority) {
//       case "low":
//         return { bg: "#f1f5f9", color: "#64748b" };
//       case "medium":
//         return { bg: "#e8f1fb", color: "#1e5799" };
//       case "high":
//         return { bg: "#fef3e2", color: "#d97706" };
//       case "urgent":
//         return { bg: "#feeaeb", color: "#dc2626" };
//       default:
//         return { bg: "#f1f5f9", color: "#64748b" };
//     }
//   };

//   const getStatusStyle = (status) => {
//     switch (status) {
//       case "open":
//         return { bg: "#feeaeb", color: "#dc2626" };
//       case "in_progress":
//         return { bg: "#fef3e2", color: "#d97706" };
//       case "resolved":
//         return { bg: "#e7f9eb", color: "#059669" };
//       case "closed":
//         return { bg: "#e7f9eb", color: "#059669" };
//       default:
//         return { bg: "#f1f5f9", color: "#64748b" };
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "80vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         }}
//       >
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             border: "4px solid #e2e8f0",
//             borderTop: "4px solid #1e5799",
//             borderRadius: "50%",
//             animation: "spin 0.8s linear infinite",
//           }}
//         />
//         <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         padding: "24px",
//         fontFamily: "'Poppins', 'DM Sans', sans-serif",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1500px",
//           margin: "0 auto",
//           background: "#ffffff",
//           borderRadius: "20px",
//           boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//           border: "1.5px solid #e2e8f0",
//           overflow: "hidden",
//         }}
//       >
//         {/* 🎯 GRADIENT TOP BAR */}
//         <div
//           style={{
//             height: "5px",
//             background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//           }}
//         />

//         {/* 🎯 HEADER */}
//         <div
//           style={{
//             padding: "24px 30px",
//             borderBottom: "1.5px solid #e2e8f0",
//             background: "linear-gradient(135deg, #ffffff, #f8fafc)",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: "16px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <div
//                 style={{
//                   width: "48px",
//                   height: "48px",
//                   borderRadius: "14px",
//                   background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "#ffffff",
//                   fontSize: "22px",
//                   boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   flexShrink: 0,
//                 }}
//               >
//                 <FaTicketAlt />
//               </div>
//               <div>
//                 <h2
//                   style={{
//                     margin: 0,
//                     fontSize: "22px",
//                     fontWeight: "800",
//                     color: "#1e3a5f",
//                     letterSpacing: "-0.3px",
//                   }}
//                 >
//                   All Ticket Support
//                 </h2>
//                 <p
//                   style={{
//                     margin: "2px 0 0",
//                     fontSize: "12.5px",
//                     color: "#64748b",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Manage all customer support tickets
//                 </p>
//               </div>
//             </div>

//             {/* 🎯 Important Notice */}
//             <div
//               style={{
//                 background: "#fef3e2",
//                 border: "1.5px solid #fed7aa",
//                 borderRadius: "12px",
//                 padding: "10px 16px",
//                 fontSize: "12.5px",
//                 fontWeight: "600",
//                 color: "#d97706",
//                 maxWidth: "520px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               <span style={{ fontSize: "16px", flexShrink: 0 }}>⚠️</span>
//               <span>
//                 Admin must mark ticket as <strong>"Closed"</strong> after
//                 resolution. Otherwise customer will continue seeing it as
//                 Open/In Progress.
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* 🎯 TABLE */}
//         <div style={{ padding: "24px 30px" }}>
//           <div
//             style={{
//               overflowX: "auto",
//               borderRadius: "14px",
//               border: "1.5px solid #e2e8f0",
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "13px",
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                   }}
//                 >
//                   {[
//                     "S.N",
//                     "Ticket No",
//                     "Subject",
//                     "Description",
//                     "Priority",
//                     "Assigned",
//                     "Status",
//                     "Attachment",
//                     "Resolution",
//                     "Created",
//                     "Action",
//                   ].map((th, i) => (
//                     <th
//                       key={i}
//                       style={{
//                         padding: "14px 12px",
//                         color: "#ffffff",
//                         fontWeight: "700",
//                         fontSize: "11.5px",
//                         textAlign: "left",
//                         letterSpacing: "0.5px",
//                         textTransform: "uppercase",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {th}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {TicketSupportLists.length > 0 ? (
//                   TicketSupportLists.map((item, index) => (
//                     <tr
//                       key={item.id}
//                       style={{
//                         borderBottom: "1px solid #f1f5f9",
//                         transition: "background 0.2s ease",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.background = "#f8fafc")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.background = "transparent")
//                       }
//                     >
//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           fontWeight: "700",
//                           color: "#1e5799",
//                         }}
//                       >
//                         {(currentPage - 1) * 10 + index + 1}
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           fontWeight: "700",
//                           color: "#1e3a5f",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         #{item.ticket_no || "NA"}
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           minWidth: "220px",
//                           maxWidth: "280px",
//                           color: "#334155",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {item.subject || "NA"}
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           minWidth: "220px",
//                           maxWidth: "300px",
//                           color: "#64748b",
//                           fontSize: "12.5px",
//                           lineHeight: "1.5",
//                         }}
//                       >
//                         {item.description || "NA"}
//                       </td>

//                       <td style={{ padding: "14px 12px" }}>
//                         <span
//                           style={{
//                             display: "inline-block",
//                             padding: "4px 12px",
//                             borderRadius: "20px",
//                             fontSize: "11px",
//                             fontWeight: "700",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.5px",
//                             background: getPriorityStyle(item.priority).bg,
//                             color: getPriorityStyle(item.priority).color,
//                           }}
//                         >
//                           {item.priority || "NA"}
//                         </span>
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           fontWeight: "600",
//                           color: "#334155",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {item.assigned_to || "Admin"}
//                       </td>

//                       <td style={{ padding: "14px 12px" }}>
//                         <span
//                           style={{
//                             display: "inline-block",
//                             padding: "4px 12px",
//                             borderRadius: "20px",
//                             fontSize: "11px",
//                             fontWeight: "700",
//                             textTransform: "capitalize",
//                             background: getStatusStyle(item.status).bg,
//                             color: getStatusStyle(item.status).color,
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {item.status || "NA"}
//                         </span>
//                       </td>

//                       <td style={{ padding: "14px 12px" }}>
//                         {item.attachment ? (
//                           item.attachment.endsWith(".pdf") ? (
//                             <a
//                               href={`${profileImage}/${item.attachment}`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               style={{
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: "5px",
//                                 padding: "6px 10px",
//                                 borderRadius: "8px",
//                                 background: "#feeaeb",
//                                 color: "#dc2626",
//                                 fontSize: "11.5px",
//                                 fontWeight: "700",
//                                 textDecoration: "none",
//                                 whiteSpace: "nowrap",
//                               }}
//                             >
//                               📄 PDF
//                             </a>
//                           ) : (
//                             <a
//                               href={`${profileImage}/${item.attachment}`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={`${profileImage}/${item.attachment}`}
//                                 alt="attachment"
//                                 width="45px"
//                                 height="45px"
//                                 style={{
//                                   objectFit: "cover",
//                                   cursor: "pointer",
//                                   borderRadius: "8px",
//                                   border: "1.5px solid #e2e8f0",
//                                 }}
//                               />
//                             </a>
//                           )
//                         ) : (
//                           <span style={{ color: "#94a3b8", fontSize: "12px" }}>
//                             —
//                           </span>
//                         )}
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           minWidth: "180px",
//                           maxWidth: "220px",
//                           color: "#64748b",
//                           fontSize: "12.5px",
//                           lineHeight: "1.5",
//                         }}
//                       >
//                         {item.resolution || (
//                           <span style={{ color: "#cbd5e1" }}>---</span>
//                         )}
//                       </td>

//                       <td
//                         style={{
//                           padding: "14px 12px",
//                           color: "#64748b",
//                           fontSize: "12.5px",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         {item.created_at
//                           ? new Date(item.created_at).toLocaleDateString()
//                           : "NA"}
//                       </td>

//                       {/* Action Button */}
//                       <td style={{ padding: "14px 12px" }}>
//                         <button
//                           data-bs-toggle={
//                             item.status === "closed" ? "" : "modal"
//                           }
//                           data-bs-target={
//                             item.status === "closed" ? "" : `#editModal${item.id}`
//                           }
//                           disabled={item.status === "closed"}
//                           style={{
//                             padding: "8px 16px",
//                             borderRadius: "10px",
//                             border: "none",
//                             background:
//                               item.status === "closed"
//                                 ? "#e7f9eb"
//                                 : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                             color:
//                               item.status === "closed" ? "#059669" : "#ffffff",
//                             fontSize: "12px",
//                             fontWeight: "700",
//                             cursor:
//                               item.status === "closed"
//                                 ? "not-allowed"
//                                 : "pointer",
//                             transition: "all 0.2s ease",
//                             whiteSpace: "nowrap",
//                             boxShadow:
//                               item.status === "closed"
//                                 ? "none"
//                                 : "0 4px 12px rgba(30, 87, 153, 0.3)",
//                             display: "inline-flex",
//                             alignItems: "center",
//                             gap: "6px",
//                           }}
//                         >
//                           {item.status === "closed" ? (
//                             <>
//                               <FaCheckCircle /> Closed
//                             </>
//                           ) : (
//                             <>🔧 Fix Issue</>
//                           )}
//                         </button>

//                         {/* 🎯 MODAL — Fix Issue */}
//                         <div
//                           className="modal fade"
//                           id={`editModal${item.id}`}
//                           tabIndex="-1"
//                           aria-hidden="true"
//                         >
//                           <div className="modal-dialog modal-lg modal-dialog-centered">
//                             <div
//                               className="modal-content"
//                               style={{
//                                 borderRadius: "16px",
//                                 border: "none",
//                                 overflow: "hidden",
//                                 boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
//                               }}
//                             >
//                               {/* Modal Header */}
//                               <div
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                                   padding: "20px 24px",
//                                   color: "#ffffff",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "space-between",
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "12px",
//                                   }}
//                                 >
//                                   <div
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "10px",
//                                       background: "rgba(255,255,255,0.2)",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       fontSize: "18px",
//                                     }}
//                                   >
//                                     🎫
//                                   </div>
//                                   <div>
//                                     <h5
//                                       style={{
//                                         margin: 0,
//                                         fontSize: "17px",
//                                         fontWeight: "800",
//                                       }}
//                                     >
//                                       Fix Issue — #{item.ticket_no}
//                                     </h5>
//                                     <p
//                                       style={{
//                                         margin: 0,
//                                         fontSize: "11.5px",
//                                         opacity: 0.85,
//                                       }}
//                                     >
//                                       Mark as closed after resolution
//                                     </p>
//                                   </div>
//                                 </div>

//                                 <button
//                                   type="button"
//                                   className="btn-close btn-close-white"
//                                   data-bs-dismiss="modal"
//                                   aria-label="Close"
//                                 ></button>
//                               </div>

//                               {/* Modal Body */}
//                               <div
//                                 style={{
//                                   padding: "24px",
//                                   maxHeight: "65vh",
//                                   overflowY: "auto",
//                                   background: "#f8fafc",
//                                 }}
//                               >
//                                 {/* Warning Notice */}
//                                 <div
//                                   style={{
//                                     background: "#feeaeb",
//                                     border: "1.5px solid #fecaca",
//                                     borderRadius: "10px",
//                                     padding: "12px 16px",
//                                     marginBottom: "20px",
//                                     fontSize: "12.5px",
//                                     fontWeight: "600",
//                                     color: "#dc2626",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "8px",
//                                   }}
//                                 >
//                                   ⚠️ Important: Mark ticket as{" "}
//                                   <strong>"Closed"</strong> after resolution,
//                                   otherwise customer will still see it as Open.
//                                 </div>

//                                 {/* Subject */}
//                                 <div style={{ marginBottom: "16px" }}>
//                                   <label
//                                     style={{
//                                       display: "block",
//                                       fontSize: "12.5px",
//                                       fontWeight: "700",
//                                       color: "#1e3a5f",
//                                       marginBottom: "6px",
//                                     }}
//                                   >
//                                     Issue Subject Details
//                                   </label>
//                                   <input
//                                     type="text"
//                                     value={item.subject || ""}
//                                     disabled
//                                     style={{
//                                       width: "100%",
//                                       padding: "10px 14px",
//                                       borderRadius: "10px",
//                                       border: "1.5px solid #e2e8f0",
//                                       background: "#ffffff",
//                                       fontSize: "13.5px",
//                                       color: "#64748b",
//                                       boxSizing: "border-box",
//                                     }}
//                                   />
//                                 </div>

//                                 {/* Description */}
//                                 <div style={{ marginBottom: "16px" }}>
//                                   <label
//                                     style={{
//                                       display: "block",
//                                       fontSize: "12.5px",
//                                       fontWeight: "700",
//                                       color: "#1e3a5f",
//                                       marginBottom: "6px",
//                                     }}
//                                   >
//                                     Issue Descriptions
//                                   </label>
//                                   <textarea
//                                     rows="3"
//                                     value={item.description || ""}
//                                     disabled
//                                     style={{
//                                       width: "100%",
//                                       padding: "10px 14px",
//                                       borderRadius: "10px",
//                                       border: "1.5px solid #e2e8f0",
//                                       background: "#ffffff",
//                                       fontSize: "13.5px",
//                                       color: "#64748b",
//                                       boxSizing: "border-box",
//                                       resize: "none",
//                                     }}
//                                   />
//                                 </div>

//                                 {/* Grid — Priority + Status */}
//                                 <div
//                                   style={{
//                                     display: "grid",
//                                     gridTemplateColumns: "1fr 1fr",
//                                     gap: "14px",
//                                     marginBottom: "16px",
//                                   }}
//                                 >
//                                   <div>
//                                     <label
//                                       style={{
//                                         display: "block",
//                                         fontSize: "12.5px",
//                                         fontWeight: "700",
//                                         color: "#1e3a5f",
//                                         marginBottom: "6px",
//                                       }}
//                                     >
//                                       Issue Priority
//                                     </label>
//                                     <input
//                                       type="text"
//                                       value={item.priority || ""}
//                                       disabled
//                                       style={{
//                                         width: "100%",
//                                         padding: "10px 14px",
//                                         borderRadius: "10px",
//                                         border: "1.5px solid #e2e8f0",
//                                         background: "#ffffff",
//                                         fontSize: "13.5px",
//                                         color: "#64748b",
//                                         textTransform: "capitalize",
//                                         boxSizing: "border-box",
//                                       }}
//                                     />
//                                   </div>
//                                   <div>
//                                     <label
//                                       style={{
//                                         display: "block",
//                                         fontSize: "12.5px",
//                                         fontWeight: "700",
//                                         color: "#1e3a5f",
//                                         marginBottom: "6px",
//                                       }}
//                                     >
//                                       Issue Status{" "}
//                                       <span style={{ color: "#dc2626" }}>*</span>
//                                     </label>
//                                     <select
//                                       value={item.status || ""}
//                                       onChange={(e) =>
//                                         handleStatusChange(item.id, e.target.value)
//                                       }
//                                       style={{
//                                         width: "100%",
//                                         padding: "10px 14px",
//                                         borderRadius: "10px",
//                                         border: "1.5px solid #1e5799",
//                                         background: "#ffffff",
//                                         fontSize: "13.5px",
//                                         fontWeight: "600",
//                                         color: "#1e5799",
//                                         cursor: "pointer",
//                                         outline: "none",
//                                         boxSizing: "border-box",
//                                       }}
//                                     >
//                                       <option value="open">Open</option>
//                                       <option value="in_progress">
//                                         In Progress
//                                       </option>
//                                       <option value="resolved">Resolved</option>
//                                       <option value="closed">Closed</option>
//                                     </select>
//                                   </div>
//                                 </div>

//                                 {/* Resolution */}
//                                 <div style={{ marginBottom: "16px" }}>
//                                   <label
//                                     style={{
//                                       display: "block",
//                                       fontSize: "12.5px",
//                                       fontWeight: "700",
//                                       color: "#1e3a5f",
//                                       marginBottom: "6px",
//                                     }}
//                                   >
//                                     Resolution / Remark{" "}
//                                     <span style={{ color: "#dc2626" }}>*</span>
//                                   </label>
//                                   <textarea
//                                     rows="4"
//                                     placeholder="Enter Issue Resolution Details (Min 500 Characters)"
//                                     value={item.resolution || ""}
//                                     onChange={(e) =>
//                                       handleResolutionChange(
//                                         item.id,
//                                         e.target.value
//                                       )
//                                     }
//                                     style={{
//                                       width: "100%",
//                                       padding: "10px 14px",
//                                       borderRadius: "10px",
//                                       border: errors[item.id]
//                                         ? "1.5px solid #dc2626"
//                                         : "1.5px solid #e2e8f0",
//                                       background: "#ffffff",
//                                       fontSize: "13.5px",
//                                       color: "#1e3a5f",
//                                       outline: "none",
//                                       resize: "vertical",
//                                       boxSizing: "border-box",
//                                       transition: "all 0.25s ease",
//                                     }}
//                                     onFocus={(e) => {
//                                       e.target.style.borderColor = "#1e5799";
//                                       e.target.style.boxShadow =
//                                         "0 0 0 4px rgba(30,87,153,0.1)";
//                                     }}
//                                     onBlur={(e) => {
//                                       e.target.style.borderColor = errors[item.id]
//                                         ? "#dc2626"
//                                         : "#e2e8f0";
//                                       e.target.style.boxShadow = "none";
//                                     }}
//                                   />
//                                   {errors[item.id] && (
//                                     <p
//                                       style={{
//                                         color: "#dc2626",
//                                         fontSize: "11.5px",
//                                         margin: "6px 0 0",
//                                         fontWeight: "600",
//                                       }}
//                                     >
//                                       {errors[item.id]}
//                                     </p>
//                                   )}
//                                 </div>

//                                 {/* Grid — Resolved By + Date */}
//                                 <div
//                                   style={{
//                                     display: "grid",
//                                     gridTemplateColumns: "1fr 1fr",
//                                     gap: "14px",
//                                   }}
//                                 >
//                                   <div>
//                                     <label
//                                       style={{
//                                         display: "block",
//                                         fontSize: "12.5px",
//                                         fontWeight: "700",
//                                         color: "#1e3a5f",
//                                         marginBottom: "6px",
//                                       }}
//                                     >
//                                       Resolved By
//                                     </label>
//                                     <input
//                                       type="text"
//                                       value="Admin"
//                                       disabled
//                                       style={{
//                                         width: "100%",
//                                         padding: "10px 14px",
//                                         borderRadius: "10px",
//                                         border: "1.5px solid #e2e8f0",
//                                         background: "#ffffff",
//                                         fontSize: "13.5px",
//                                         color: "#64748b",
//                                         boxSizing: "border-box",
//                                       }}
//                                     />
//                                   </div>
//                                   <div>
//                                     <label
//                                       style={{
//                                         display: "block",
//                                         fontSize: "12.5px",
//                                         fontWeight: "700",
//                                         color: "#1e3a5f",
//                                         marginBottom: "6px",
//                                       }}
//                                     >
//                                       Resolution Date
//                                     </label>
//                                     <input
//                                       type="text"
//                                       value={
//                                         new Date()
//                                           .toLocaleDateString("en-GB")
//                                           .replace(/\//g, "-") +
//                                         " " +
//                                         new Date().toLocaleTimeString("en-GB")
//                                       }
//                                       disabled
//                                       style={{
//                                         width: "100%",
//                                         padding: "10px 14px",
//                                         borderRadius: "10px",
//                                         border: "1.5px solid #e2e8f0",
//                                         background: "#ffffff",
//                                         fontSize: "13.5px",
//                                         color: "#64748b",
//                                         boxSizing: "border-box",
//                                       }}
//                                     />
//                                   </div>
//                                 </div>
//                               </div>

//                               {/* Modal Footer */}
//                               <div
//                                 style={{
//                                   padding: "16px 24px",
//                                   background: "#ffffff",
//                                   borderTop: "1.5px solid #e2e8f0",
//                                   display: "flex",
//                                   justifyContent: "flex-end",
//                                   gap: "10px",
//                                 }}
//                               >
//                                 <button
//                                   type="button"
//                                   data-bs-dismiss="modal"
//                                   style={{
//                                     padding: "10px 22px",
//                                     borderRadius: "10px",
//                                     border: "1.5px solid #e2e8f0",
//                                     background: "#ffffff",
//                                     color: "#64748b",
//                                     fontSize: "13px",
//                                     fontWeight: "700",
//                                     cursor: "pointer",
//                                     transition: "all 0.2s ease",
//                                   }}
//                                 >
//                                   Cancel
//                                 </button>

//                                 <button
//                                   type="button"
//                                   onClick={() => updateTicketRequest(item)}
//                                   style={{
//                                     padding: "10px 22px",
//                                     borderRadius: "10px",
//                                     border: "none",
//                                     background:
//                                       "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                                     color: "#ffffff",
//                                     fontSize: "13px",
//                                     fontWeight: "700",
//                                     cursor: "pointer",
//                                     transition: "all 0.2s ease",
//                                     boxShadow:
//                                       "0 4px 12px rgba(30, 87, 153, 0.3)",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "6px",
//                                   }}
//                                 >
//                                   <FaCheckCircle /> Update Ticket
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="11"
//                       style={{
//                         padding: "50px",
//                         textAlign: "center",
//                         color: "#94a3b8",
//                         fontWeight: "600",
//                       }}
//                     >
//                       📭 No tickets found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 🎯 PAGINATION */}
//           {totalPages > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 marginTop: "20px",
//                 gap: "6px",
//               }}
//             >
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <HiOutlineChevronLeft />
//               </button>

//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   style={{
//                     width: "38px",
//                     height: "38px",
//                     borderRadius: "10px",
//                     border:
//                       index + 1 === currentPage
//                         ? "none"
//                         : "1.5px solid #e2e8f0",
//                     background:
//                       index + 1 === currentPage
//                         ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
//                         : "#ffffff",
//                     color: index + 1 === currentPage ? "#ffffff" : "#334155",
//                     fontWeight: "700",
//                     fontSize: "13px",
//                     cursor: "pointer",
//                     boxShadow:
//                       index + 1 === currentPage
//                         ? "0 6px 16px rgba(30, 87, 153, 0.3)"
//                         : "none",
//                   }}
//                 >
//                   {index + 1}
//                 </button>
//               ))}

//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   width: "38px",
//                   height: "38px",
//                   borderRadius: "10px",
//                   border: "1.5px solid #e2e8f0",
//                   background: "#ffffff",
//                   color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor:
//                     currentPage === totalPages ? "not-allowed" : "pointer",
//                 }}
//               >
//                 <HiChevronRight />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AllCreatedTicketSupport;

import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { HiOutlineChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi2";
import { FaTicketAlt, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;
const profileImage = `${process.env.REACT_APP_Image_URL}/support_tickets/`;

// 🎯 Mock data — same file ke andar
const MOCK_TICKETS = [
  { id: 1, ticket_no: "TKT-1001", subject: "Payment not received for booking #4521", description: "Customer has paid via UPI but booking amount is still showing pending. Please verify transaction ID TXN9988776.", priority: "high", assigned_to: "Admin", status: "open", attachment: null, resolution: "", created_at: "2026-02-14T10:25:00Z" },
  { id: 2, ticket_no: "TKT-1002", subject: "Property images not loading on listing page", description: "All the property images on the listing page show broken links. This is affecting all users.", priority: "urgent", assigned_to: "Admin", status: "in_progress", attachment: "ticket_sample.pdf", resolution: "", created_at: "2026-02-13T15:10:00Z" },
  { id: 3, ticket_no: "TKT-1003", subject: "Unable to update KYC documents", description: "When uploading Aadhaar card, an error pops up saying 'Invalid format' even though file is JPG.", priority: "medium", assigned_to: "Admin", status: "resolved", attachment: "kyc_issue_screenshot.jpg", resolution: "Cleared cache and re-uploaded. Customer now able to upload KYC documents successfully.", created_at: "2026-02-12T09:45:00Z" },
  { id: 4, ticket_no: "TKT-1004", subject: "Login OTP not receiving on mobile", description: "Customer mobile number 98765xxxxx is not receiving login OTP since last 2 days.", priority: "high", assigned_to: "Admin", status: "closed", attachment: null, resolution: "Issue resolved by re-syncing SMS gateway. OTP delivery confirmed working.", created_at: "2026-02-11T18:30:00Z" },
  { id: 5, ticket_no: "TKT-1005", subject: "Request for refund of cancelled booking", description: "Booking #7823 was cancelled by customer. Refund not processed even after 7 days.", priority: "urgent", assigned_to: "Admin", status: "open", attachment: null, resolution: "", created_at: "2026-02-10T11:00:00Z" },
  { id: 6, ticket_no: "TKT-1006", subject: "Website slow on mobile devices", description: "Website takes more than 10 seconds to load on mobile. Desktop works fine.", priority: "low", assigned_to: "Admin", status: "in_progress", attachment: null, resolution: "", created_at: "2026-02-09T14:20:00Z" },
  { id: 7, ticket_no: "TKT-1007", subject: "Wrong property shown in search results", description: "Searching for 2BHK in Andheri shows 3BHK properties in Thane.", priority: "medium", assigned_to: "Admin", status: "open", attachment: null, resolution: "", created_at: "2026-02-08T08:15:00Z" },
  { id: 8, ticket_no: "TKT-1008", subject: "Agent commission statement missing", description: "Agent dashboard shows zero commission for January 2026 even though 4 deals closed.", priority: "high", assigned_to: "Admin", status: "closed", attachment: "commission_report.pdf", resolution: "Generated and re-uploaded commission statement. Agent has been notified.", created_at: "2026-02-07T12:40:00Z" },
  { id: 9, ticket_no: "TKT-1009", subject: "Broken link on About Us page", description: "The 'Contact Us' link on About Us page redirects to 404.", priority: "low", assigned_to: "Admin", status: "resolved", attachment: null, resolution: "Fixed the anchor link and deployed to production.", created_at: "2026-02-06T16:55:00Z" },
  { id: 10, ticket_no: "TKT-1010", subject: "Duplicate listings appearing in city page", description: "Same property is listed 3 times on Mumbai city page with different IDs.", priority: "medium", assigned_to: "Admin", status: "in_progress", attachment: null, resolution: "", created_at: "2026-02-05T10:05:00Z" },
  { id: 11, ticket_no: "TKT-1011", subject: "Unable to download invoice PDF", description: "Customer cannot download invoice for booking #9901. Click does nothing.", priority: "high", assigned_to: "Admin", status: "open", attachment: null, resolution: "", created_at: "2026-02-04T13:30:00Z" },
  { id: 12, ticket_no: "TKT-1012", subject: "Chat support not responding", description: "Live chat widget stuck on 'Connecting...' since yesterday morning.", priority: "urgent", assigned_to: "Admin", status: "closed", attachment: null, resolution: "Restarted chat server. Service restored.", created_at: "2026-02-03T09:50:00Z" }
];

function AllCreatedTicketSupport() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [TicketSupportLists, setTicketSupportLists] = useState([]);
  const [usingMock, setUsingMock] = useState(false);
  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem("token");

  // 🔹 Mock pagination
  const paginateMock = (page = 1, limit = 10) => {
    const start = (page - 1) * limit;
    setTicketSupportLists(MOCK_TICKETS.slice(start, start + limit));
    setTotalPages(Math.ceil(MOCK_TICKETS.length / limit));
    setCurrentPage(page);
    setUsingMock(true);
  };

  const fetchCreatedTicketSupport = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();

      if (!token) {
        console.warn("⚠️ No token — using mock data");
        paginateMock(page);
        return;
      }

      const response = await fetch(
        `${API_URL}/created-ticket-support-lists?page=${page}&limit=10`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // 🛡️ Safe JSON parse
      const rawText = await response.text();
      let data = null;
      try {
        data = JSON.parse(rawText);
      } catch {
        console.warn("⚠️ Invalid JSON — using mock data");
        paginateMock(page);
        return;
      }

      if (!response.ok) {
        console.warn(`⚠️ API error ${response.status} — using mock data`);
        paginateMock(page);
        return;
      }

      const realData = data.data || [];
      if (!Array.isArray(realData) || realData.length === 0) {
        console.warn("⚠️ API empty — using mock data");
        paginateMock(page);
        return;
      }

      // ✅ Real data
      setUsingMock(false);
      setTicketSupportLists(realData);
      setTotalPages(data.totalPages || data.data?.totalPages || 1);
      setCurrentPage(page);
    } catch (err) {
      console.warn("⚠️ Fetch failed — using mock data:", err.message);
      paginateMock(page);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreatedTicketSupport(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber) => {
    if (!totalPages || pageNumber < 1 || pageNumber > totalPages) return;
    if (usingMock) {
      paginateMock(pageNumber);
      return;
    }
    setCurrentPage(pageNumber);
    fetchCreatedTicketSupport(pageNumber);
  };

  const handleStatusChange = (id, value) => {
    setTicketSupportLists((prev) =>
      prev.map((item) => (item.id === id ? { ...item, status: value } : item))
    );
  };

  const handleResolutionChange = (id, value) => {
    setTicketSupportLists((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, resolution: value } : item
      )
    );
  };

  const updateTicketRequest = async (item) => {
    if (!item.resolution || item.resolution.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        [item.id]: "Resolution / Remark is required",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, [item.id]: "" }));

    const payload = {
      ticket_no: item.ticket_no,
      status: item.status,
      resolution: item.resolution,
      resolved_by: "Admin",
      assigned_to: "Admin",
      resolved_at: new Date().toISOString().slice(0, 19).replace("T", " "),
    };

    if (usingMock) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: `Ticket #${item.ticket_no} updated (demo mode).`,
        timer: 1600,
        showConfirmButton: false,
      });
      return;
    }

    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/update-ticket-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const rawText = await response.text();
      let result = null;
      try {
        result = JSON.parse(rawText);
      } catch {
        throw new Error("Invalid server response");
      }

      if (response.ok && (result.success === "1" || result.success === true)) {
        Swal.fire("Success", result.message || "Updated", "success");
        fetchCreatedTicketSupport(currentPage);
      } else {
        throw new Error(result.message || "Update failed");
      }
    } catch (err) {
      console.warn("⚠️ Update failed, doing local update:", err.message);
      Swal.fire({
        icon: "success",
        title: "Updated (Offline)",
        text: `Ticket #${item.ticket_no} updated locally.`,
        timer: 1600,
        showConfirmButton: false,
      });
    }
  };

  const getPriorityStyle = (priority) => {
    switch (priority) {
      case "low": return { bg: "#f1f5f9", color: "#64748b" };
      case "medium": return { bg: "#e8f1fb", color: "#1e5799" };
      case "high": return { bg: "#fef3e2", color: "#d97706" };
      case "urgent": return { bg: "#feeaeb", color: "#dc2626" };
      default: return { bg: "#f1f5f9", color: "#64748b" };
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "open": return { bg: "#feeaeb", color: "#dc2626" };
      case "in_progress": return { bg: "#fef3e2", color: "#d97706" };
      case "resolved": return { bg: "#e7f9eb", color: "#059669" };
      case "closed": return { bg: "#e7f9eb", color: "#059669" };
      default: return { bg: "#f1f5f9", color: "#64748b" };
    }
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1500px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "20px",
          boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
          border: "1.5px solid #e2e8f0",
          overflow: "hidden",
        }}
      >
        {/* Top Gradient */}
        <div
          style={{
            height: "5px",
            background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
          }}
        />

        {/* Header */}
        <div
          style={{
            padding: "24px 30px",
            borderBottom: "1.5px solid #e2e8f0",
            background: "linear-gradient(135deg, #ffffff, #f8fafc)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                <FaTicketAlt />
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    letterSpacing: "-0.3px",
                  }}
                >
                  All Ticket Support
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Manage all customer support tickets
                </p>
              </div>
            </div>

            <div
              style={{
                background: "#fef3e2",
                border: "1.5px solid #fed7aa",
                borderRadius: "12px",
                padding: "10px 16px",
                fontSize: "12.5px",
                fontWeight: "600",
                color: "#d97706",
                maxWidth: "520px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ fontSize: "16px", flexShrink: 0 }}>⚠️</span>
              <span>
                Admin must mark ticket as <strong>"Closed"</strong> after
                resolution. Otherwise customer will continue seeing it as
                Open/In Progress.
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div style={{ padding: "24px 30px" }}>
          <div
            style={{
              overflowX: "auto",
              borderRadius: "14px",
              border: "1.5px solid #e2e8f0",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "13px",
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  }}
                >
                  {[
                    "S.N",
                    "Ticket No",
                    "Subject",
                    "Description",
                    "Priority",
                    "Assigned",
                    "Status",
                    "Attachment",
                    "Resolution",
                    "Created",
                    "Action",
                  ].map((th, i) => (
                    <th
                      key={i}
                      style={{
                        padding: "14px 12px",
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "11.5px",
                        textAlign: "left",
                        letterSpacing: "0.5px",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {th}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {TicketSupportLists.length > 0 ? (
                  TicketSupportLists.map((item, index) => (
                    <tr
                      key={item.id}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f8fafc")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      <td style={{ padding: "14px 12px", fontWeight: "700", color: "#1e5799" }}>
                        {(currentPage - 1) * 10 + index + 1}
                      </td>
                      <td style={{ padding: "14px 12px", fontWeight: "700", color: "#1e3a5f", whiteSpace: "nowrap" }}>
                        #{item.ticket_no || "NA"}
                      </td>
                      <td style={{ padding: "14px 12px", minWidth: "220px", maxWidth: "280px", color: "#334155", fontWeight: "600" }}>
                        {item.subject || "NA"}
                      </td>
                      <td style={{ padding: "14px 12px", minWidth: "220px", maxWidth: "300px", color: "#64748b", fontSize: "12.5px", lineHeight: "1.5" }}>
                        {item.description || "NA"}
                      </td>
                      <td style={{ padding: "14px 12px" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: "700",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            background: getPriorityStyle(item.priority).bg,
                            color: getPriorityStyle(item.priority).color,
                          }}
                        >
                          {item.priority || "NA"}
                        </span>
                      </td>
                      <td style={{ padding: "14px 12px", fontWeight: "600", color: "#334155", whiteSpace: "nowrap" }}>
                        {item.assigned_to || "Admin"}
                      </td>
                      <td style={{ padding: "14px 12px" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "11px",
                            fontWeight: "700",
                            textTransform: "capitalize",
                            background: getStatusStyle(item.status).bg,
                            color: getStatusStyle(item.status).color,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.status || "NA"}
                        </span>
                      </td>
                      <td style={{ padding: "14px 12px" }}>
                        {item.attachment ? (
                          item.attachment.endsWith(".pdf") ? (
                            <a
                              href={`${profileImage}/${item.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "5px",
                                padding: "6px 10px",
                                borderRadius: "8px",
                                background: "#feeaeb",
                                color: "#dc2626",
                                fontSize: "11.5px",
                                fontWeight: "700",
                                textDecoration: "none",
                                whiteSpace: "nowrap",
                              }}
                            >
                              📄 PDF
                            </a>
                          ) : (
                            <a
                              href={`${profileImage}/${item.attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={`${profileImage}/${item.attachment}`}
                                alt="attachment"
                                width="45"
                                height="45"
                                style={{
                                  objectFit: "cover",
                                  cursor: "pointer",
                                  borderRadius: "8px",
                                  border: "1.5px solid #e2e8f0",
                                }}
                              />
                            </a>
                          )
                        ) : (
                          <span style={{ color: "#94a3b8", fontSize: "12px" }}>—</span>
                        )}
                      </td>
                      <td style={{ padding: "14px 12px", minWidth: "180px", maxWidth: "220px", color: "#64748b", fontSize: "12.5px", lineHeight: "1.5" }}>
                        {item.resolution || (
                          <span style={{ color: "#cbd5e1" }}>---</span>
                        )}
                      </td>
                      <td style={{ padding: "14px 12px", color: "#64748b", fontSize: "12.5px", whiteSpace: "nowrap" }}>
                        {item.created_at
                          ? new Date(item.created_at).toLocaleDateString()
                          : "NA"}
                      </td>
                      <td style={{ padding: "14px 12px" }}>
                        <button
                          data-bs-toggle={item.status === "closed" ? "" : "modal"}
                          data-bs-target={item.status === "closed" ? "" : `#editModal${item.id}`}
                          disabled={item.status === "closed"}
                          style={{
                            padding: "8px 16px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                              item.status === "closed"
                                ? "#e7f9eb"
                                : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: item.status === "closed" ? "#059669" : "#ffffff",
                            fontSize: "12px",
                            fontWeight: "700",
                            cursor: item.status === "closed" ? "not-allowed" : "pointer",
                            whiteSpace: "nowrap",
                            boxShadow:
                              item.status === "closed"
                                ? "none"
                                : "0 4px 12px rgba(30, 87, 153, 0.3)",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          {item.status === "closed" ? (
                            <>
                              <FaCheckCircle /> Closed
                            </>
                          ) : (
                            <>🔧 Fix Issue</>
                          )}
                        </button>

                        {/* Modal */}
                        <div
                          className="modal fade"
                          id={`editModal${item.id}`}
                          tabIndex="-1"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div
                              className="modal-content"
                              style={{
                                borderRadius: "16px",
                                border: "none",
                                overflow: "hidden",
                                boxShadow: "0 20px 60px rgba(30, 87, 153, 0.25)",
                              }}
                            >
                              <div
                                style={{
                                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                                  padding: "20px 24px",
                                  color: "#ffffff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "10px",
                                      background: "rgba(255,255,255,0.2)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "18px",
                                    }}
                                  >
                                    🎫
                                  </div>
                                  <div>
                                    <h5 style={{ margin: 0, fontSize: "17px", fontWeight: "800" }}>
                                      Fix Issue — #{item.ticket_no}
                                    </h5>
                                    <p style={{ margin: 0, fontSize: "11.5px", opacity: 0.85 }}>
                                      Mark as closed after resolution
                                    </p>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="btn-close btn-close-white"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>

                              <div
                                style={{
                                  padding: "24px",
                                  maxHeight: "65vh",
                                  overflowY: "auto",
                                  background: "#f8fafc",
                                }}
                              >
                                <div
                                  style={{
                                    background: "#feeaeb",
                                    border: "1.5px solid #fecaca",
                                    borderRadius: "10px",
                                    padding: "12px 16px",
                                    marginBottom: "20px",
                                    fontSize: "12.5px",
                                    fontWeight: "600",
                                    color: "#dc2626",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  ⚠️ Important: Mark ticket as{" "}
                                  <strong>"Closed"</strong> after resolution,
                                  otherwise customer will still see it as Open.
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                  <label style={labelStyle}>Issue Subject Details</label>
                                  <input
                                    type="text"
                                    value={item.subject || ""}
                                    disabled
                                    style={inputDisabled}
                                  />
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                  <label style={labelStyle}>Issue Descriptions</label>
                                  <textarea
                                    rows="3"
                                    value={item.description || ""}
                                    disabled
                                    style={{ ...inputDisabled, resize: "none" }}
                                  />
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "14px",
                                    marginBottom: "16px",
                                  }}
                                >
                                  <div>
                                    <label style={labelStyle}>Issue Priority</label>
                                    <input
                                      type="text"
                                      value={item.priority || ""}
                                      disabled
                                      style={{ ...inputDisabled, textTransform: "capitalize" }}
                                    />
                                  </div>
                                  <div>
                                    <label style={labelStyle}>
                                      Issue Status <span style={{ color: "#dc2626" }}>*</span>
                                    </label>
                                    <select
                                      value={item.status || ""}
                                      onChange={(e) => handleStatusChange(item.id, e.target.value)}
                                      style={{
                                        width: "100%",
                                        padding: "10px 14px",
                                        borderRadius: "10px",
                                        border: "1.5px solid #1e5799",
                                        background: "#ffffff",
                                        fontSize: "13.5px",
                                        fontWeight: "600",
                                        color: "#1e5799",
                                        cursor: "pointer",
                                        outline: "none",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                      <option value="open">Open</option>
                                      <option value="in_progress">In Progress</option>
                                      <option value="resolved">Resolved</option>
                                      <option value="closed">Closed</option>
                                    </select>
                                  </div>
                                </div>

                                <div style={{ marginBottom: "16px" }}>
                                  <label style={labelStyle}>
                                    Resolution / Remark <span style={{ color: "#dc2626" }}>*</span>
                                  </label>
                                  <textarea
                                    rows="4"
                                    placeholder="Enter Issue Resolution Details (Min 500 Characters)"
                                    value={item.resolution || ""}
                                    onChange={(e) => handleResolutionChange(item.id, e.target.value)}
                                    style={{
                                      ...inputDisabled,
                                      color: "#1e3a5f",
                                      border: errors[item.id]
                                        ? "1.5px solid #dc2626"
                                        : "1.5px solid #e2e8f0",
                                      resize: "vertical",
                                    }}
                                  />
                                  {errors[item.id] && (
                                    <p
                                      style={{
                                        color: "#dc2626",
                                        fontSize: "11.5px",
                                        margin: "6px 0 0",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {errors[item.id]}
                                    </p>
                                  )}
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "14px",
                                  }}
                                >
                                  <div>
                                    <label style={labelStyle}>Resolved By</label>
                                    <input type="text" value="Admin" disabled style={inputDisabled} />
                                  </div>
                                  <div>
                                    <label style={labelStyle}>Resolution Date</label>
                                    <input
                                      type="text"
                                      value={
                                        new Date().toLocaleDateString("en-GB").replace(/\//g, "-") +
                                        " " +
                                        new Date().toLocaleTimeString("en-GB")
                                      }
                                      disabled
                                      style={inputDisabled}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  padding: "16px 24px",
                                  background: "#ffffff",
                                  borderTop: "1.5px solid #e2e8f0",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  gap: "10px",
                                }}
                              >
                                <button
                                  type="button"
                                  data-bs-dismiss="modal"
                                  style={{
                                    padding: "10px 22px",
                                    borderRadius: "10px",
                                    border: "1.5px solid #e2e8f0",
                                    background: "#ffffff",
                                    color: "#64748b",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  onClick={() => updateTicketRequest(item)}
                                  style={{
                                    padding: "10px 22px",
                                    borderRadius: "10px",
                                    border: "none",
                                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                                    color: "#ffffff",
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <FaCheckCircle /> Update Ticket
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="11"
                      style={{
                        padding: "50px",
                        textAlign: "center",
                        color: "#94a3b8",
                        fontWeight: "600",
                      }}
                    >
                      📭 No tickets found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                gap: "6px",
              }}
            >
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={paginationBtn(currentPage === 1)}
              >
                <HiOutlineChevronLeft />
              </button>

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    border: index + 1 === currentPage ? "none" : "1.5px solid #e2e8f0",
                    background:
                      index + 1 === currentPage
                        ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                        : "#ffffff",
                    color: index + 1 === currentPage ? "#ffffff" : "#334155",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow:
                      index + 1 === currentPage
                        ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                        : "none",
                  }}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={paginationBtn(currentPage === totalPages)}
              >
                <HiChevronRight />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// 🎨 Shared styles
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputDisabled = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  background: "#ffffff",
  fontSize: "13.5px",
  color: "#64748b",
  boxSizing: "border-box",
};

const paginationBtn = (disabled) => ({
  width: "38px",
  height: "38px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  background: "#ffffff",
  color: disabled ? "#cbd5e1" : "#1e5799",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: disabled ? "not-allowed" : "pointer",
});

export default AllCreatedTicketSupport;